const fetchItems = state => state.items;

export default {
  fetchItems,
};
